import React from 'react';
import PropTypes from 'prop-types';

import Alert from '../../../../../common/Alert/Alert';
import { User } from '../types';

const NotEducatorsWarning = React.memo(({ notEducatorUsers }) => {
  const users = notEducatorUsers.map(
    (user) => `${user.firstName} ${user.lastName}`
  );
  const namesOfUsers = [users.slice(0, -1).join(', '), users.slice(-1)].join(
    ' and '
  );
  const warningMessage =
    users.length === 1
      ? `${users[0]} is not an educator in any other space.`
      : `${namesOfUsers} are not educators in any other space.`;

  return (
    <Alert alertType="warning">
      {`${warningMessage} Make sure you selected the right user before adding them as an educator to this space.`}
    </Alert>
  );
});

NotEducatorsWarning.propTypes = {
  notEducatorUsers: PropTypes.arrayOf(User).isRequired,
};

export default NotEducatorsWarning;
